import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

function Mobilemenu({ onClose }) {
   const navigate = useNavigate();
  const location = useLocation();

  const closeMenu = () => {
    if (onClose) {
      onClose();
    }
  };

  const handleAddOnServicesClick = (event) => {
    event.preventDefault();

    const scrollToSection = () => {
      document
        .getElementById('addon-services-section')
        ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    closeMenu();

    if (location.pathname === '/' || location.pathname === '/home') {
      setTimeout(scrollToSection, 80);
      return;
    }

    navigate('/home#addon-services-section');
    setTimeout(scrollToSection, 180);
  };

  const handleAboutLocationBanner = (event) => {
    event.preventDefault();

    const scrollToSection = () => {
      document
        .getElementById('about-location-banner')
        ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    closeMenu();

    if (location.pathname === '/' || location.pathname === '/home') {
      setTimeout(scrollToSection, 80);
      return;
    }

    navigate('/home#about-location-banner');
    setTimeout(scrollToSection, 180);
  };
 
  
 
  return (
    <nav className="navbar-mobile">
       <ul className="navbar-nav">

          <li className="nav-item first">
                         <Link className='nav-link' to='/home' onClick={closeMenu}>Home</Link>
                      </li>
          
                      <li className="nav-item">
                         <Link className='nav-link' to='/home#about-location-banner' onClick={handleAboutLocationBanner}>Sets</Link>
                      </li>        
                      
                      <li className="nav-item">
                         <Link className='nav-link' to='/home#addon-services-section' onClick={handleAddOnServicesClick}>Add On Services</Link>
                      </li>
          
                       <li className="nav-item">
                         <Link className='nav-link' to='#' onClick={closeMenu}> Book Now</Link>
                      </li>
          
                        <li className="nav-item">
                         <Link className='nav-link' to='#' onClick={closeMenu}>About Us</Link>
                      </li>
          
                       <li className="nav-item">
                         <Link className='nav-link' to='/contact' onClick={closeMenu}>Contact us</Link>
                      </li>
          

            

        </ul>
    </nav>
  );
}

export default Mobilemenu;
